import React, { useCallback } from 'react';

const DEFAULT_SCROLL_BUFFER = 140;

export function useScrollToCallbackRef(
  shouldScroll: boolean,
  scrollContainer: HTMLElement,
  cleanup: (NodeNode) => void,
  scrollBuffer = DEFAULT_SCROLL_BUFFER
): React.RefCallback<HTMLElement> {
  const callbackRef = useCallback(
    node => {
      if (!node || !scrollContainer || !shouldScroll) {
        return;
      }

      const scrollY =
        node.getBoundingClientRect().top + window.scrollY - scrollBuffer;

      scrollContainer.scrollTop = scrollY;
      cleanup(node);
    },
    [cleanup, scrollBuffer, scrollContainer, shouldScroll]
  );

  return callbackRef;
}
